webpackJsonp([17],{

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__(18);

var _reactStatic = __webpack_require__(12);

var _storyblokReact = __webpack_require__(31);

var _storyblokReact2 = _interopRequireDefault(_storyblokReact);

__webpack_require__(489);

var _download = __webpack_require__(586);

var _download2 = _interopRequireDefault(_download);

var _preview = __webpack_require__(587);

var _preview2 = _interopRequireDefault(_preview);

var _share = __webpack_require__(588);

var _share2 = _interopRequireDefault(_share);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Acknowledgments = function (_React$Component) {
  _inherits(Acknowledgments, _React$Component);

  function Acknowledgments() {
    _classCallCheck(this, Acknowledgments);

    return _possibleConstructorReturn(this, (Acknowledgments.__proto__ || Object.getPrototypeOf(Acknowledgments)).apply(this, arguments));
  }

  _createClass(Acknowledgments, [{
    key: 'render',
    value: function render() {
      var _ref = this.props.story || { content: {} },
          content = _ref.content;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactHelmet.Helmet,
          null,
          _react2.default.createElement(
            'title',
            null,
            content && content.top[0].title
          )
        ),
        content && content.top.map(function (el) {
          return _react2.default.createElement(
            _storyblokReact2.default,
            { key: el._uid, content: el },
            _react2.default.createElement(
              'div',
              {
                className: 'hero hero--small',
                style: {
                  backgroundImage: 'url(' + el.image + ')',
                  backgroundPosition: 'center ' + (el.image_offset ? el.image_offset + '%' : '50%')
                }
              },
              _react2.default.createElement('div', { className: 'hero__overlay' }),
              _react2.default.createElement(
                'div',
                { className: 'wrapper' },
                _react2.default.createElement(
                  'h1',
                  { className: 'hero__title hero--small__title' },
                  el.title
                )
              )
            )
          );
        }),
        _react2.default.createElement(
          'div',
          { className: 'documentsPart' },
          content && content.map_section.map(function (el) {
            if (el.component === 'Section Title') {
              return _react2.default.createElement(
                _storyblokReact2.default,
                { key: el._uid, content: el },
                _react2.default.createElement(
                  'h2',
                  { className: 'DocumentsTitleMain' },
                  el.text
                )
              );
            }

            if (el.component === 'Page Subtitle') {
              return _react2.default.createElement(
                _storyblokReact2.default,
                { key: el._uid, content: el },
                _react2.default.createElement(
                  'p',
                  { className: 'DocumentsTitleSecondary' },
                  el.text
                )
              );
            }
          }),
          _react2.default.createElement(
            'div',
            { className: 'documentsListList' },
            content && content.map_section.map(function (el) {
              if (el.component === 'Document') {
                return _react2.default.createElement(
                  _storyblokReact2.default,
                  { key: el._uid, content: el },
                  _react2.default.createElement(
                    'div',
                    { className: 'DocumentsList' },
                    _react2.default.createElement(
                      'div',
                      { className: 'firstPartDocList' },
                      _react2.default.createElement(
                        'p',
                        { className: 'DocumentTitle' },
                        el.title
                      ),
                      _react2.default.createElement(
                        'p',
                        { className: 'DocumentAuthor' },
                        el.author
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'DocumentsListActions' },
                      _react2.default.createElement(
                        'a',
                        { href: el.file, rel: 'noopener noreferrer', target: '_blank' },
                        _react2.default.createElement(
                          'div',
                          { className: 'assetContainer' },
                          _react2.default.createElement('img', { className: 'assetShare', src: _preview2.default, alt: 'share PDF' })
                        )
                      ),
                      _react2.default.createElement(
                        'a',
                        { href: el.file, download: true, target: 'blank' },
                        _react2.default.createElement(
                          'div',
                          { className: 'assetContainer' },
                          _react2.default.createElement('img', { className: 'assetShare', src: _download2.default, alt: 'share PDF' })
                        )
                      ),
                      _react2.default.createElement(
                        'a',
                        { href: el.file, download: true, target: 'blank' },
                        _react2.default.createElement(
                          'div',
                          { className: 'assetContainer' },
                          _react2.default.createElement('img', { className: 'assetShare', src: _share2.default, alt: 'share PDF' })
                        )
                      )
                    )
                  )
                );
              }
            })
          )
        )
      );
    }
  }]);

  return Acknowledgments;
}(_react2.default.Component);

exports.default = (0, _reactStatic.withRouteData)(Acknowledgments);

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 586:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA4CAYAAAC2TwutAAAAAXNSR0IArs4c6QAABLtJREFUaAXtWk2MFEUUrtc9sysiisENF2M0cvAAmBBMloB6MruLLO789CScXJGDiEriyUiIE3/iyYOKoCsx8SCJM04Pyu72TIKa8JMACWE3Xkwk8cABCEZXF1mG6a7nq9ae9NYMy051z/TGdF2q6tX7+96rv64ZYF0oRsG4z9Zmn0dk9zNMWEdz4+c6bRY6bWD0x9G7/vzt8gUC9ZhrCxhqyIbNXHWik7a1TioXumd/v7ylAUoQkAEC7BTNTpaOA3MQ+mQAyFgTTeYJ2u84sKAOqsrHwFQjF5VcnLGoIq9qN86YauSikoszFlXkVe3GGVONXFRyccaiiryq3ThjqpGLSi7OWFSRV7UbZ0w1clHJxRmLKvKqdhOqgp5cytz2OKDdsz7dfz4Pee7RVet0aehBjfNHepdr019ttf5S1aM8FfOY10YKg9+hXZ/iDp6bLp45bRSGAj2rpQqDb3DOf7WRnbhxHS+mSwMbug7sp9LZZ+n1c9gzjAz7bcZ/2HFs+AGP1k49Uhx8i3S8Tw+q7iyidh934J12dPh5lTPGEZoA0EPo2rm5etvg0sWB/Qwx73dMtOn9XXkGKANLILPI8ozsDGVx3c2b9e9TZmpV81gzJVUY2seRvd08QsAAjrSiL4amDKyYm7yiafpzZORv2RAirmf2jTuCo0y9iYy/K8uLPgD7vJSd/LDV2GJogX9tyRYHnnSQTdI0vKeFwSnQ2GHk7MC8MYCT4MrQmmpZYKxsWC9RxkitWgkMTJhdCBwwmKONYJnfvVY0b5zAfGZmrd1BQAldoQATimir3kLry7pN5gTLHQuA9qmZnXw5KChhKDRgQhkdrps5R4t2uBWi306hxX6oZFT2hAFK2A0VmFCoBA7gYDlrvRIWKOGH8q4ohFsVM2OdTjB9kLa12VbjMo3AfHI0xEx5+kPPmKeY1twmBFZdaFpSVA/Qb9GvejJh1g1go+WRlTN27XWG/FHQ4Gzfww8dGts4Vg9izAXHWIU2lXtlPWGBEjboV+0X3JMP2ZflXOWUsNUARgynaFve7DlAU+SjslHZ6/VVa1pz/XRJrs4DB/AxTb/XVHV6ckZh6zqbOedpJ04KGh0jjqbBE6WsdcFdYzu+3b7aD8oVRJbxFASpac2dgUTiKbpJjFMUpwH0nWGAEj7ZDLd7oESfMOh06xG3oX9v0nbt1krR8RdiaqL5x9tpl9Pj08Tf+BJoR3ZBXiAfpbsJIrh+h74rLuhIFwdjYF0Mdiim4oyFEsYuKvl/Z6yeBFsOJh12SToTGge4PL4U+rTT98p+IHAXi5ux5b3sWhMDw56MObRRpi+V/n9B3yT7A0xzsTQyMlIY+IWY1kiMF3UN9iaTPVM1R2/KqsTbtW7Crq2uM07XPXxRNqrr7JlSpnrcfcMTg4Twa0rtPolxjcNxwqnVJHK03dvdzGn5XNGcFSeEd43NY9ndiQ9ooGlKRguhPev09rO/mCvemgfsyLaJP3TADH0gLq30LBIbXbK/MI3qYY+9kTFB+MaontRBe5qalzyGpV6LTxVaRu+Z2couv6+NzcNPFP+8nrl2dRcwnqbVt5bGVtFtf14Q/PzdbpPT18nmJfrT9HEdkgdL2WM/yz78A6b7gIKHM0C1AAAAAElFTkSuQmCC"

/***/ }),

/***/ 587:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAA6CAYAAADP/mu6AAAAAXNSR0IArs4c6QAAA5JJREFUaAXtmk9IVEEcx3/z9q262V+rU5QRROAtMgoMLSvcVSLXdZcOHSSiTkHRIQgCCToFFXQIPJQXL/tcXUp3y0soBRIWEtGhIMoSi8rCNFJ336/fLDz3/+60O/sneAPy5jfznd98+Do7b9yRARVXv2N3GPE6IO6nsJq3FaowgFkANqqCclXzBCZznYe5+lv36bo+hoAVuSbJcdyCYlGODLiC47mMVwj6ZgmgOWs1hvVht9dRlxM4DdqTy0AZYxCgJgQ44vYe2/av+Vi7t4XGRwutwTFQmD/akmcNoQ4RT2fKwoC9UYEd0DzBr5l0sX1J4MDglt/96EKsKJ96h7elTQcYypqDsYmaiormu8fv/8qqJYEiIiqKBrH+x+KS/1zAUSkyXwnA2Rxj7EMqONokmj/O633d2J2VK6sg1QT5teG8itZGgn+XJo9rUhu/k6ZvpbkE4ACa58GUimoj/1CukMRV8IxTc1yLa0oISgLOGTTP0DS9PZvoLfo6gSkSIuqXOzTH+VR9vK1k4HxyeuV/tgI7SMvmJY8Tiw76jfZ++8nEdh6XFJwDRPZui62Zls0LHscVpM0Z8R7fUuPaKSg5OAca7Bj8vs5adZhefs8SAQFBJX6tw+doiO0rC3AO1Ov0/1y1WjlKzj+NBeR12iZtdKYaij3XlA04B+xrDc6psMZO8KM8jisI6+lc02O0qUalaE/GNjq99rRHgBDwNz7SKSG5kPMNXY+7qnoP9f4pODiq1k8QWo5SIFbSqS7pwxYVZK7Nzc5sIMVMwZeKGrK9oom+ZMYR761QK+kzXIRdRfNoYYvCTvGNTRwvu7LgjnMEX+fDAHlkp+pUdiQxRcHXuIHhdwdHqF7r8rXt0MP6VgvDyK/c6E/1DAOcoD9CzqbqKxq4MbnPNcxPhelOhoYs8qTdZ29cQ0xQlKUSM5+0qgkuzUrBRKbjgkZJk5mOS7NSMJHpuKBR0mSm49KsFExkOi5olDSZ6bg0KwUTmY4LGiVNZjouzUrBRKbjgkZJk5mOS7NSMJHpuKBR0mSm49KsFExkOi5olDTZf+t40tfM9KV1m1Ozb5FmTX6JdiXeYyyFFiM3GwTO3tMt13YjPyLspJh+yq+Qqcubamu/cTKFgoHyQ0xL9KSnvidyhadstlmvkOx5Wmm5dDD2m1nYJQMncg/D/51oekG/SHfmTbSm1hqdZfIkLHyrMMttX2dgwmD6C0i/6MdlvekhAAAAAElFTkSuQmCC"

/***/ }),

/***/ 588:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/Acknowledgments.7811d03b.js